<template>
<div class="head-box" id="j-head_bar">
    <div class="col header" style="width: 100% !important;margin: 0 auto !important;justify-content: center !important;">
        <a class="logo" href="index"><img src="../images/logo.svg" alt=""></a>
        <div v-if="langluageType == 'ch'" class="header-r">
            <ul class="nav" id="j-nav">
                <li>
                    <el-link @click="textColor('index')" class="menu-item" :class="url == '/index'||''?'active':''" :underline="false" href="index"  style="color: #333333;">主场运营</el-link>
                </li>
                <li>
                    <el-link @click="textColor('shop')" class="menu-item" :class="url == '/shop'||''?'active':''" :underline="false" href="shop"  style="color: #333333;">印刷服务</el-link>
                </li>
                <li>
                    <el-link @click="textColor('paas2')" class="menu-item" :class="url == '/paas2'||''?'active':''" :underline="false" href="paas2"  style="color: #333333;">商旅服务</el-link>
                </li>
                <li>
                    <el-link  :underline="false" class="custom-link-color" href="http://design.expopaas.com/site/list.html"  target="_blank" style="color: #333333;">搭建服务</el-link>
                </li>
                <!-- <li>
                    <a style="color: #333333;">产品</a>
                    <div class="menu-group">
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articlework" target="_blank" style="font-weight: normal;">Work主场云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articlepro" target="_blank" style="font-weight: normal;">Project展装云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articlecrm" target="_blank" style="font-weight: normal;">CRM招展云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articleguest" target="_blank" style="font-weight: normal;">Guest观众云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articledesign" target="_blank" style="font-weight: normal;">Design设计云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articlecargo" target="_blank" style="font-weight: normal;">CarGo物流云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articlehub" target="_blank" style="font-weight: normal;">Hub场馆云</a>
                        <a class="menu-item styleCol" href="https://www.expopaas.com/articleAi" target="_blank" style="font-weight: normal;">A.I.智能云</a>
                    </div>
                </li> -->
                <!-- <li>
                    <a :class="url == '/solution'||url == '/solution2'||url == '/solution3'||url == '/solution4'?'active':''" style="color: #333333;">解决方案</a>
                    <div class="menu-group" style="padding: 5px 3px;">
                        <el-link @click="textColor('solution')" class="custom-link-color" :class="url == '/solution'?'active':''" :underline="false" href="solution" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">主办解决方案</el-link>
                        <el-link @click="textColor('solution2')" class="custom-link-color" :class="url == '/solution2'?'active':''" :underline="false" href="solution2" style="padding: 8px 0px;width: 124px;font-size: 14px;font-weight: normal;">主场解决方案</el-link>
                        <el-link @click="textColor('solution3')" class="custom-link-color" :class="url == '/solution3'?'active':''" :underline="false" href="solution3" style="padding: 8px 0px;width: 124px;font-size: 14px;font-weight: normal;">展装解决方案</el-link>
                        <el-link @click="textColor('solution4')" class="custom-link-color" :class="url == '/solution4'?'active':''" :underline="false" href="solution4" style="padding: 8px 0px;width: 124px;font-size: 14px;font-weight: normal;">场馆解决方案</el-link>
                    </div>
                </li>
                <li>
                    <a :class="url == '/paas'||url == '/shop'||url == '/paas2'?'active':''" style="color: #333333;">平台服务</a>
                    <div class="menu-group">
                        <el-link @click="textColor('paas')" class="custom-link-color" :class="url == '/paas'?'active':''" :underline="false" href="paas" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">主场运营</el-link>
                        <el-link @click="textColor('shop')" class="custom-link-color" :class="url == '/shop'?'active':''" :underline="false" href="shop" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">印刷服务</el-link>
                        <el-link @click="textColor('paas-2')" class="custom-link-color" :class="url == '/paas2'?'active':''" :underline="false" href="paas2" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">商旅服务</el-link>
                        <el-link :underline="false" class="custom-link-color" href="http://design.expopaas.com/site/list.html" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">搭建服务</el-link>
                    </div>
                </li> -->
                <!-- <li @@if (context.page==='activity' ) { class='active' }><a href="@@webRoot/page/activity.html">合作生态</a></li> -->
                <!-- <li>
                    <a :class="url == '/activity'||url == '/cooperation#xmhz'||url == '/cooperation#gjst'?'active':''" style="color: #333333;">合作生态</a>
                    <div class="menu-group">
                        <el-link @click="textColor('cooperation')" class="menu-item custom-link-color" :class="url == '/cooperation#xmhz'?'active':''" :underline="false" href="cooperation#xmhz" style="padding: 8px 0px;width: 124px;font-size: 14px;font-weight: normal;">项目合作</el-link>
                        <el-link @click="textColor('cooperation')" class="menu-item custom-link-color" :class="url == '/cooperation#gjst'?'active':''" :underline="false" href="cooperation#gjst" style="padding: 8px 0px; width: 124px;font-size: 14px;font-weight: normal;">共建生态</el-link>
                    </div>
                </li> -->
                <li><el-link @click="textColor('news')" class="menu-item'" :class="url == '/news'?'active':''" :underline="false" href="news"  style="color: #333333;">新闻动态</el-link></li>
                <li><el-link @click="textColor('about')" class="menu-item'" :class="url == '/about'?'active':''" :underline="false" href="about"  style="color: #333333;">关于我们</el-link></li>
                <li><el-link @click="textColor('file')" class="menu-item'" :class="url == '/file'?'active':''" :underline="false" href="file"  style="color: #333333;">资料下载</el-link></li>

                <!-- https://www.exposcm.com/Article/index/category/zcfw.html -->
            </ul>
            <div class="login" style="opacity: 0;">
                <span class="j-btn-login a1" id="" href="javascript:;">&emsp;&emsp;&emsp;&emsp;</span>
                <span class="j-user-down a1" id="" href="javascript:;"></span>
                <ul class="user-op j-user-down">
                    <li id="">&emsp;&emsp;&emsp;&emsp;</li>
                </ul>
            </div>
            <el-dropdown @command="handleCommand" style="font-size: 18px;padding-left: 10px !important;border-left: 2px solid transparent;margin-left: 10px !important;">
                <span class="el-dropdown-link" style="color:#409EFF;">
                    {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="ch">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div v-else class="header-r" style="margin-left: 54px;">
            <ul class="nav" id="j-nav" style="margin-right: 160px;">
                <li>
                    <el-link @click="textColor('index')" class="menu-item" :class="url == '/index'?'active':''" :underline="false" href="index" style="font-size: 18px;font-weight: 700;color: #333333;">Home Operation</el-link>
                </li>
                <!-- <li><el-link @click="textColor('paas')" :class="url == '/paas'?'active':''" :underline="false" href="paas" style="font-size: 18px;font-weight: 700;color: #333333;">Home Operation</el-link></li> -->
                <li><el-link @click="textColor('shop')" :class="url == '/shop'?'active':''" :underline="false" href="shop" style="font-size: 18px;font-weight: 700;color: #333333;">Printing Services</el-link></li>
                <li><el-link @click="textColor('paas-2')" :class="url == '/paas2'?'active':''" :underline="false" href="paas2" style="font-size: 18px;font-weight: 700;color: #333333;">Business travel services</el-link></li>
                <li><el-link @click="textColor('about')" class="menu-item'" :class="url == '/about'?'active':''" :underline="false" href="about"  style="font-size: 18px;font-weight: 700;color: #333333;">About Us</el-link></li>
            </ul>
            <div v-if="langluageType == 'ch'" class="login">
                <a class="j-btn-login a1" id="j-login" href="javascript:;">Login</a>
                <a class="j-user-down a1" id="j-user-down" href="javascript:;"></a>
                <ul class="user-op j-user-down">
                    <li id="j-loginout">Out Login</li>
                </ul>
            </div>
            <el-dropdown @command="handleCommand" style="font-size: 18px;padding-left: 10px !important;border-left: 2px solid #409EFF;margin-left: 10px !important;">
                <span class="el-dropdown-link" style="color:#409EFF;">
                    {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="ch">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
    <!-- 登录 中文 -->
    <div v-if="langluageType == 'ch'" class="dialog-box" id="j-login-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-login">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" name="phone" type="text" placeholder="手机号">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-login-sub" href="javascript:;">登录</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>没有账号？</span>
                                    <a class="btn-text j-btn-register" href="javascript:;">立即注册</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 登录 英文 -->
        <div v-else class="dialog-box" id="j-login-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-login">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" name="phone" type="text" placeholder="Phone number">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="Pasword length 6-16 characters">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-login-sub" href="javascript:;">Log in</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>No account?</span>
                                    <a class="btn-text j-btn-register" href="javascript:;">Register Now</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册 中文-->
        <div v-if="langluageType == 'ch'" class="dialog-box" id="j-register-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-register">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" id="register-phone" name="phone" type="text" placeholder="手机号" autocomplete="new-password">
                                </li>
                                <li class="input-box">
                                    <div class="input-block">
                                        <input class="input-item" name="code" type="text" placeholder="验证码" autocomplete="new-password">
                                    </div>
                                    <div class="btn code-btn" id="btn-register-code" href="javascript:;">获取验证码</div>
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="密码长度6-16位" autocomplete="new-password">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="email" type="text" placeholder="邮箱" autocomplete="new-password">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-register-sub" href="javascript:;">注册</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>已有账号？</span>
                                    <a class="btn-text j-btn-login" href="javascript:;">立即登录</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- 注册 英文-->
        <div v-else class="dialog-box" id="j-register-dialog">
            <div class="dialog-bg">
                <div class="dialog">
                    <div class="d-head">
                        <span class="d-title"></span>
                        <img class="d-close" src="../assets/icon-no.svg" alt="">
                    </div>
                    <div class="d-con">
                        <form class="login-box-2" id="form-register">
                            <div></div>
                            <ul>
                                <li class="input-block">
                                    <input class="input-item" id="register-phone" name="phone" type="text" placeholder="Phone number" autocomplete="new-password">
                                </li>
                                <li class="input-box">
                                    <div class="input-block">
                                        <input class="input-item" name="code" type="text" placeholder="Verification Code" autocomplete="new-password">
                                    </div>
                                    <div class="btn code-btn" id="btn-register-code" href="javascript:;">get</div>
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="password" type="password" placeholder="Pasword length 6-16 characters" autocomplete="new-password">
                                    <img class="icon-img j-eye" :src="require('../assets/image/'+imgUrl)" alt="">
                                </li>
                                <li class="input-block">
                                    <input class="input-item" name="email" type="text" placeholder="Mail" autocomplete="new-password">
                                </li>
                            </ul>
                            <a class="btn-sub" id="j-register-sub" href="javascript:;">register</a>
                            <div class="login-foot">
                                <a class="btn-text" href=""></a>
                                <div>
                                    <span>Already have an account?</span>
                                    <a class="btn-text j-btn-login" href="javascript:;">Log in</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>
<script>
// import aaa from '../js/common'
import $ from 'jquery'
    import'../page/jquery.cookie.js'
    var _api = 'https://scm-member-api.expopaas.com'
    var regex = /^1\d{10}$/
	// 登录信息
	var user_token = $.cookie('company_user_token')
	// 设置登录状态
	
	function login_status(){
        if($.cookie('company_user_token')){
            console.log("第一");
            
           user_token = $.cookie('company_user_token') 
           $('#j-user-down').show().text($.cookie('company_user_phone'))
        }else if(getQueryVariable('company_user_token')){
            console.log("第二",getQueryVariable('company_user_token'),getQueryVariable('company_user_phone'));
            user_token = getQueryVariable('company_user_token')
            $('#j-user-down').show().text(getQueryVariable('company_user_phone'))
            $.cookie('company_user_token', getQueryVariable('company_user_token'), { expires: 1, path: '/' })
			$.cookie('company_user_phone', getQueryVariable('company_user_phone'))
        }else{
            console.log("第三");
            
            $('#j-login').show()
			$('#j-user-down').hide()
        }
		

		// if(user_token){
		// 	$('#j-user-down').show().text($.cookie('company_user_phone'))
		// 	$('#j-login').hide()
		// }else{
		// 	$('#j-login').show()
		// 	$('#j-user-down').hide()
		// }
	}
    function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            console.log("pair",pair);
            if(pair[0] == 'company_user_token'){
                pair[1] = pair[1].replace(/%20/g, ' ');
            }
            
             return pair[1]; 
            }
    }
    return (false);
}

	

	// 登录
	function login_sub(data){
        let that = this
		if(!data.phone || !data.password){
			
			return
		}
        data.mobilePhone = data.phone
		$.ajax({
			type: "POST",
			url: _api+'/web/v1/auth/login',
			data: data,
			dataType: "json",
			success: function (res) {
				if(res.code == 0){
                    toast({msg: '登录成功'})
					$.cookie('company_user_token', 'Bearer '+res.data.token, { expires: 1, path: '/' })
					$.cookie('company_user_phone', data.phone, { expires: 1, path: '/' })
					
					login_status()

					$('#j-login-dialog').fadeOut()
					// setTimeout(() => {
						// location.reload()
                        // location.href = '/activity?company_user_token='+'Bearer '+res.data.token+'&company_user_phone='+data.phone
                        // that.$router.push({ path: '/activity', query: { company_user_token: 'Bearer '+res.data.token,company_user_phone:data.phone } });
					// }, 1000);
				}else {
                    toast({msg: res.msg})
                }
			}
		});
	}

	// 注册
	function register_sub(data){
		$.ajax({
			type: "POST",
			url: _api+"/web/v1/auth/register",
			data: data,
			dataType: "json",
			success: function (res) {
                
				if(res.code == 0){
				    toast({msg: "注册成功"})
					$('#j-register-dialog').fadeOut()
				}else{
                    toast({msg: res.msg})
                }
			}
		});
	}

    // 点击 非classname区域
    function click_no_this_dom(classname, callback){
        $(document).bind('click',function(e){
            var e = e || window.event; //浏览器兼容性
            var elem = e.target || e.srcElement;
            while (elem) { //循环判断至跟节点，防止点击的是div子元素
                if ($(elem).hasClass(classname)) {
                    return;
                }
                elem = elem.parentNode;
            }
            callback&&callback()
        });
    }

    function _get_code(btn, phone, rul){
        var _time = 60;
        $(btn).on('click',function(){
            // var _this = $(this)
            if($(this).hasClass('is-off')){

            }else{
                console.log("ppp",phone);
                
                var _phone = $(phone).val()
                
                if(_phone){
                    if(!regex.test(_phone)){
                        console.log("ppp2",phone);
                        toast({ msg: '请输入正确的手机号' })
                    }else{
                        _time = 60
                        set_time()
                        get_code(_phone)
                    }
                }
            }
        })
        function set_time(){
            if( _time<= 0){
                $(btn).removeClass('is-off').html('获取验证码')
            }else{
                $(btn).addClass('is-off').html('('+_time+')')
                setTimeout(function() {
                    _time--
                    set_time()
                }, 1000)
            }
        }
        function get_code(phone){
            $.ajax({
                type: "POST",
                url: _api+rul,
                data:{mobilePhone: phone},
                headers: {Authorization: user_token|| ''},
                dataType: "json",
                success: function (res) {
                    if(res.code == 0){
                        toast({msg: '发送成功'})
                    }else{
                        // _time = 0
                        toast({msg:  res.msg})
                    }
                }
            });
        }
    }

    // 获取form表单数据
    function getFormData(formId){
        var data = {};
        var results = $(formId).serializeArray();
        $.each(results,function(index,item){
            //文本表单的值不为空才处理
            if(item.value && $.trim(item.value)!=""){
                if(!data[item.name]){
                    data[item.name]=item.value;
                }else{
                    //name属性相同的表单，值以英文,拼接
                    data[item.name]=data[item.name]+','+item.value;
                }
            }
        });
        return data;
    }

    // 提示信息
    function toast(n) {
        console.log('1');
        
        var t = document;
        var toastId = document.getElementById('toastId');
        console.log('2');
        if(toastId){
            console.log('3');
            toastId.remove();
            console.log('4');
            // toastId.parentNode.removeChild(toastId);
        }
        console.log('5');
        var e = t.createElement("div")
        e.id = 'toastId';
        e.innerHTML = n.msg 
        console.log('6');
        t.body.appendChild(e);
        var r = setTimeout(function() {
            clearTimeout(r)
            e.remove();
            // t.body.removeChild(e)
        }, n.time || 2e3)
        console.log('7');
    }
export default {
    // mixins: [aaa],
        data(){
            return {
                url:'',
                imgUrl:'eye-0.png',
                lang:'中文',
                langluageType:''
            }
        },
        watch: {
            $route: {
                handler(route) {
                if(this&&this.$route){
                    this.url = this.$route.path||''
                }else{
                    this.url = ''
                }
                },
                immediate: true,
            },
        },
        created(){
            if(!sessionStorage.getItem('langluageType')){
                sessionStorage.setItem('langluageType','ch')
                this.langluageType = 'ch'
                this.lang = '中文'
            }else{
                this.lang = sessionStorage.getItem('langluageType') == 'ch'?'中文':'English'
                this.langluageType = sessionStorage.getItem('langluageType') == 'ch'?'ch':'en'
            }
        },
        mounted(){
            let that = this
            // that.login_status()
            login_status()
            // 关闭弹窗
            $('.d-close').on('click',function(){
                $(this).parents('.dialog-box').fadeOut();
            })

            // 退出
            $('#j-user-down').on('click',function(){
                $('.user-op').slideDown(200);
            })
            $('#j-loginout').on('click',function(){
                $.cookie('company_user_token', null, { expires: -1, path: '/' })
                $.cookie('company_user_phone', null, { expires: -1, path: '/' })
                login_status()
                toast({ msg: '已退出' })
                
                setTimeout(function(){
                    // location.reload()
                    history.replaceState(null, '', window.location.pathname)
                }, 1000);
                

            })
            click_no_this_dom('j-user-down', function(){
                $('.user-op').slideUp(200);
            })

            // 登录
            $('.j-btn-login').on('click',function(){
                $("#form-login")[0].reset();
                $('.dialog-box').fadeOut();
                $('#j-login-dialog').fadeIn()
            })

            // 注册
            $('.j-btn-register').on('click',function(){
                $("#form-register")[0].reset();
                $('.dialog-box').fadeOut();
                $('#j-register-dialog').fadeIn()
            })

            // 登录提交
            $('#j-login-sub').on('click',function(){
                var data = getFormData('#form-login')
                login_sub(data)
            })

            // 注册提交
            $('#j-register-sub').on('click',function(){
                var data = getFormData('#form-register')
                data.mobilePhone = data.phone
                register_sub(data)
            })

            // 获取注册验证码
            _get_code('#btn-register-code', '#register-phone', '/web/v1/auth/sendSms')

            // 查看密码
            $('.j-eye').on('click',function(){
                var _this = $(this)
                _this.toggleClass('is_on')
                // _src = _this.prop('src').split('-')
                if(_this.hasClass('is_on')){
                    that.imgUrl = 'eye-1.png'
                    _this.prev('input').prop('type','text')
                }else{
                    that.imgUrl = 'eye-0.png'
                    _this.prev('input').prop('type','password')
                }
            })
            
        },
        methods:{
            textColor(name){
                this.url = name
            },
            handleCommand(command){
                console.log("kkk",command);
                
                this.lang = command == 'ch'?'中文':'English'
                sessionStorage.setItem('langluageType',command)
                this.langluageType = command == 'ch'?'ch':'en'
                this.$router.go(0)
            }
        }
    }
</script>
<style>
.el-dropdown-menu__item:hover {
        background-color: #2083f41c !important;
        color: #409EFF !important;
    }
</style>
<style scoped>
    .active {
        color: #007CE6 !important;
    }
    .header-r{
        display: flex;
        align-items: center;
        height: 54px;
        margin-left: 104px;
        position: relative;
        /* right:50px; */
    }
    /* .header-r .login{
        height: 80px;
        margin-left: 50px;
        position: relative;
    } */
    .header-r .a1{
        /* line-height: 54px; */
        color: #303133;
        /* font-size: 15px; */
    }
    .header-r .user-op{
        position: absolute;
        top: 54px;
        right: 0;
        width: 100px;
        display: none;
        background: #fff;
        padding: 15px 0;
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);

    }
    .header-r .user-op li{
        padding: 10px 15px;
        text-align: center;
        cursor: pointer;
    }
    .header-r .user-op li:hover{
        background-color: #f6f6f6;

    }
    /* // 登录 */
    .login-box-2{
        width: 492px;
        box-sizing: border-box;
        padding: 30px;
    }
    .login-box-2 .input-block{
        margin-bottom: 20px;
    }
    .login-box-2 .btn-sub{
        display: block;
        color: #fff;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        height: 32px;
        background: #5294F9;
        border-radius: 2px;
    }
    .login-box-2 .login-foot{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 13px;
    }
    .login-box-2 .login-foot a{
        color: #5294F9;
    }
    .login-box-2 .login-foot span{
        color: #909399;
    }
    
    /* // 弹窗 */
    .dialog-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10000;
        display: none;
    }

    .dialog-box .dialog-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .dialog-box .dialog-bg .dialog {
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0px 4px 15px 0px rgba(0, 18, 41, 0.19);
    }

    .dialog-box .dialog-bg .dialog .d-head {
        height: 40px;
        background-color: #F9FAFB;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        border-radius: 2px 2px 0 0;
    }

    .dialog-box .dialog-bg .dialog .d-head .d-title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303133;
        line-height: 22px;
    }

    .dialog-box .dialog-bg .dialog .d-head .d-close {
        width: 20px;
        height: 20px;
        margin-left: 20px;
        cursor: pointer;
    }

    .dialog-box .dialog .d-con {
        /* // padding: 15px; */
        max-height: 800px;
        overflow: auto;
    }

    /* // 表单 */
    .login-box-2 .input-block{
        height: 32px;
        display: flex;
        align-items: center;
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        padding: 0 5px;
        font-size: 14px;
    }
    .login-box-2 .input-block .input-item {
        flex: 1;
        /* // padding: 0 5px; */
        outline: none;
        border: none;
    }

    .login-box-2 .input-block .icon-img {
        height: 16px;
        width: 16px;
        object-fit: contain;
        cursor: pointer;
        margin-left: 10px;
    }

    .login-box-2 .input-box {
        display: flex;
    }

    .login-box-2 .input-box .input-block {
        flex: 1;
    }

    .login-box-2 .input-box .code-btn {
        margin-left: 15px;
        width: 110px;
    }

    .login-box-2 .input-box .code-btn.is-off {
        background-color: #d4d4d4;
    }



    .login-box-2 .btn-text {
        color: #5294F9;
    }

    .login-box-2 .btn {
        display: inline-block;
        padding: 0 20px;
        box-sizing: border-box;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #5294F9;
        border-radius: 2px;
        cursor: pointer;
    }
    .menu-group{
        text-align: center !important;
    }
    .styleCol {
        color: #303133;
    }
</style>
<style>
.custom-link-color .el-link--inner {
        color: #303133;
    }
    .active .el-link--inner {
        color: #007CE6 !important;
    }
    .custom-link-color .el-link--inner:hover {
        color: #007CE6;
    }
    .el-icon-arrow-down:before {
        color: #409EFF;
    }
</style>


// WEBPACK FOOTER //
// src/common/header.vue